<template>
	<div id="ap">
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%">
					<a-row type="flex" justify="space-between">
						<a-col span="12">
							<a-page-header :title="activityTitle || '商品审核'" @back="$router.back()"></a-page-header>
						</a-col>
						<a-col span="12">
							<a-row type="flex" align="middle" justify="end" :gutter="10">
								<a-col span="5">
									<a-select v-model="param.activityId" allowClear placeholder="选择活动" style="width: 160px" @change="getList" showSearch :filterOption="filterActivityOption">
										<a-select-option v-for="act in activityList" :key="act.activityId" :value="act.activityId">{{ act.title }}</a-select-option>
									</a-select>
								</a-col>
								<a-col span="5">
									<a-input v-model="param.title" allowClear search @pressEnter="getList" @on-clear="getList" placeholder="商品名称"></a-input>
								</a-col>
								<a-col span="4">
									<a-select v-model="param.auditStatus" allowClear placeholder="审核状态" style="width: 100px" @change="getList">
										<a-select-option :value="0">待审核</a-select-option>
										<a-select-option :value="1">已通过</a-select-option>
										<a-select-option :value="2">已拒绝</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-layout>
			<a-layout-content>
				<a-table :scroll="{ x: '100%' }" :pagination="false" :style="{ background: '#FFF' }" size="small" row-key="goodsId" border :columns="keys" ref="list" :loading="loading" :data-source="data.records">
					<template slot-scope="row" slot="thumb">
						<img v-if="row.thumb" :src="row.thumb" style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px;" />
					</template>
					<template slot-scope="row" slot="title">
						{{ row.title }}
					</template>
					<template slot-scope="row" slot="storeName">
						{{ row.storeName }}
					</template>
					<template slot-scope="row" slot="price">
						<a-space direction="vertical" size="small">
							<span style="text-decoration: line-through; color: #999">原价：{{ row.originalPrice }}</span>
							<span style="color: #f5222d; font-weight: bold">秒杀：{{ row.seckillPrice }}</span>
						</a-space>
					</template>
            <template slot-scope="row" slot="stock">
                <a-space direction="vertical" size="small">
                    <span>库存：{{ row.stock }}</span>
                    <span>已售：{{ row.soldCount }}</span>
                    <span v-if="row.userLimitQuantity">限购：{{ row.userLimitQuantity }}件/人</span>
                </a-space>
            </template>
					<template slot-scope="row" slot="auditStatus">
						<a-tag v-if="row.auditStatus == '审核通过'" color="green">已通过</a-tag>
						<a-tag v-else-if="row.auditStatus == '审核拒绝'" color="red">已拒绝</a-tag>
						<a-tag v-else color="orange">待审核</a-tag>
					</template>
					<template slot-scope="row" slot="action">
						<a-button-group shape="circle" size="small">
							<a-tooltip title="通过">
								<a-button type="link" icon="check-circle" @click="audit(row, 1)" :disabled="row.auditStatus == '审核通过'"></a-button>
							</a-tooltip>
							<a-tooltip title="拒绝">
								<a-button type="link" icon="close-circle" @click="audit(row, 2)" :disabled="row.auditStatus == '审核拒绝'"></a-button>
							</a-tooltip>
						</a-button-group>
					</template>
				</a-table>
			</a-layout-content>
		</a-layout>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" @showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>

		<a-modal v-model="auditVisible" title="审核拒绝原因" :confirmLoading="auditLoading" @ok="doAudit">
			<a-form-model ref="auditFormRef" :model="auditForm" label-position="top">
				<a-form-model-item label="拒绝原因" prop="auditRemark">
					<a-textarea v-model="auditForm.auditRemark" :rows="3" placeholder="请输入拒绝原因"></a-textarea>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			auditVisible: false,
			auditLoading: false,
			activityTitle: '',
			activityList: [],
			data: { records: [] },
			param: {
				page: 1,
				limit: 20,
				activityId: '',
				title: '',
				auditStatus: ''
			},
			auditForm: {
				goodsId: '',
				auditStatus: 0,
				auditRemark: ''
			},
			keys: [
				{ title: '图片', scopedSlots: { customRender: 'thumb' }, width: 80, align: 'center' },
				{ title: '商品名称', scopedSlots: { customRender: 'title' }, ellipsis: true },
				{ title: '所属商家', scopedSlots: { customRender: 'storeName' }, width: 150 },
				{ title: '价格', scopedSlots: { customRender: 'price' }, width: 150, align: 'center' },
				{ title: '库存/销量', scopedSlots: { customRender: 'stock' }, width: 120, align: 'center' },
				{ title: '审核状态', scopedSlots: { customRender: 'auditStatus' }, width: 100, align: 'center' },
				{ title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 120 }
			]
		};
	},
	created() {
		this.activityTitle = this.$route.query.title;
		this.param.activityId = this.$route.query.activityId ? parseInt(this.$route.query.activityId) : '';
		this.loadActivityList();
		this.doRefresh();
	},
	methods: {
		loadActivityList() {
			this.http.get('/platform/activity/list', { page: 1, limit: 100 }).then(ret => {
				if (ret.code == 200) {
					this.activityList = ret.data.records || [];
				}
			});
		},
		filterActivityOption(input, option) {
			return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
		},
		audit(row, status) {
			this.auditForm = {
				goodsId: row.goodsId,
				auditStatus: status,
				auditRemark: ''
			};
			if (status === 1) {
				// 通过：无需填写意见，直接确认
				this.utils.confirm('确定要通过该商品的审核吗？').then(() => {
					this.doAudit();
				}).catch(() => {});
			} else {
				// 拒绝：弹出填写拒绝原因
				this.auditVisible = true;
			}
		},
		doAudit() {
			if (this.auditForm.auditStatus === 2 && !this.auditForm.auditRemark.trim()) {
				this.utils.error('请输入拒绝原因');
				return;
			}
			this.auditLoading = true;
			this.http
				.post('/platform/activity/goods/audit', this.auditForm)
				.then(ret => {
					if (ret.code == 200) {
						this.utils.success('操作成功！').then(() => {
							this.auditVisible = false;
							this.getList();
						});
					}
				})
				.finally(() => {
					this.auditLoading = false;
				});
		},
		getList() {
			this.loading = true;
			this.http
				.get('/platform/activity/goods/list', this.param)
				.then(ret => {
					this.data = ret.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getNext(page, pageSize) {
			this.param.page = page;
			this.param.limit = pageSize;
			this.getList();
		},
		setLimit(current, size) {
			this.param.limit = size;
			this.param.page = 1;
			this.getList();
		},
		doRefresh() {
			this.param.page = 1;
			this.getList();
		}
	}
};
</script>

<style scoped>
#ap {
	padding: 15px;
}
</style>
